module.exports = __webpack_public_path__ + "static/media/dumbbell.03e840d2.svg";